<template>
  <a-form
    :form="form"
    class="login-form"
  >
    <a-form-item>
      <a-input
        v-decorator="['userName', {initialValue: loginForm.userName, rules: [{ validator: cellPhoneValidator}]}]"
        allow-clear
        placeholder="请输入账号/手机号"
        @change="changeName"
        @blur="onBlur"
      >
        <i slot="prefix" class="iconfont login-icon icon-user_24x24" />
        <div v-if="userName" slot="suffix" class="user-suffix">{{userName}}</div>
      </a-input>
    </a-form-item>
    <a-form-item class="login-password">
      <a-input-password
        v-decorator="['password', {initialValue: loginForm.password,rules: [{ required: true, message: '请输入密码', whitespace: true}]}]"
        placeholder="请输入密码"
        @change="getFieldsValueData"
      >
        <i slot="prefix" class="iconfont login-icon icon-password_24x24" />
      </a-input-password>
    </a-form-item>
    <div class="forget"><a @click.stop="toFrogetPassword">忘记密码</a></div>
    <div class="login-submit btn-margin">
      <a-button
        :loading="loading"
        size="large"
        class="login-btn"
        html-type="submit"
        type="primary"
        :disabled="disabled"
        @click="onSubmit"
      >
        登录
      </a-button>
    </div>
  </a-form>
</template>

<script>
import baseApi from '@/api/base.js'
import { cellPhoneValidator } from '@/utils/validate'
import {redirectPath} from '@/utils/routerUtil'
import { getUserName } from '../api/auth/index'

export default {
  name: 'LoginForm',
  data() {
    return {
      loading: false,
      form: this.$form.createForm(this),
      disabled: true,
      loginForm: {
        userName: '',
        password: '',
      },
      userName: ''
    }
  },
  methods: {
    cellPhoneValidator,
    // 登录按钮校验
    getFieldsValueData() {
      this.$nextTick(() => {
        const formData = this.form.getFieldsValue();
        const value = Object.values(formData);
        if (value.includes("")) {
          this.disabled = true;
        } else {
          this.disabled = false;
        }
      });
    },
    changeName(e) {
      const {value} = e.target
      if (value.length >= 11) {
        this.getName(value)
      } else {
        this.userName = ''
      }
      this.getFieldsValueData()
    },
    async getName(value) {
      const res = await getUserName({
        telPhone: value
      })
      if(res && res.customerName){
        const name = res.customerName || ''
        this.userName = name.length > 12 ? `${name.slice(0,12)}...` : name
      } else {
        this.$message.warning('手机号未开通账号')
        this.userName = ''
      }

    },
    onBlur(e) {
      const {value} = e.target
      if (value.length >= 11) {
        this.getName(value)
      } else {
        this.userName = ''
      }
    },
    onSubmit(e) {
      e.preventDefault()
      this.form.validateFields(async (err) => {
        if (!err) {
          this.loading = true
          const userName = this.form.getFieldValue('userName')
          const password = this.form.getFieldValue('password')
          const clientCode = 'customer_account'
          const form = {
            userName,
            password,
            clientCode,
          }
          await this.$store
            .dispatch('user/login', { form, type: 'login' })
            .finally(() => {
              this.loading = false
            })
          this.afterLogin()
        }
      })
    },
    async afterLogin() {
      const res = await baseApi.getDictionary({
        status: 1,
        type: 'temp_public_customer',
      });
      const showTemperatureList = []
      res.forEach(item => {
        showTemperatureList.push(item.dictionaryCode)
      });
      localStorage.setItem('showTemperatureList', JSON.stringify(showTemperatureList))
      // todo 获取路由配置
      const {customerId,creditCode}=this.$store.state.user
      if(!customerId&&!creditCode){
        this.$router.replace('/authentication')
      } else {
        this.$router.replace(redirectPath())
      }
    },
    toFrogetPassword() {
      this.$router.push('/forgot-password')
    },
  }
}
</script>

<style lang="less" scoped>
.login-form {
  margin-top: 14%;
  .login-icon {
    font-size: 20px;
  }
  .user-suffix {
    position: absolute;
    right: 30px;
    background-image: url('../../../assets/img/frame_companyname.png');
    background-size: 100% 100%;
    padding: 4px 8px 4px 12px;
    word-break: keep-all;
    min-width: 124px;
    max-width: 200px;
    text-align: center;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
  }
  .login-password {
    padding-top: 20px;
  }
  ::v-deep {
    .ant-input-password {
      .ant-input-suffix {
        .anticon {
          color: #909399;
        }
      }
    }
    .ant-input-prefix {
      color: #666666;
      opacity: 0.65;
      .ant-input-prefix {
        left: 0;
      }
    }
    .ant-input-affix-wrapper .ant-input-prefix {
      left: 0;
    }
    .ant-input-affix-wrapper .ant-input-suffix {
      right: 0;
    }
    .ant-input {
      border: 0;
      border-bottom: 1px solid #F5F6F7;
      border-radius: 0;
      box-shadow: none;
      padding-left: 34px;
    }
    .has-error {
      .ant-input-affix-wrapper {
        .ant-input {
          border-bottom: 1px solid #ED4934;
          &:focus {
            box-shadow: none;
          }
        }
      }
    }
  }
  .forget {
    width: 100%;
    color: #06b880;
    font-size: 14px;
    text-align: right;
    margin-top: -14px;
  }
  .btn-margin {
    margin-top: 14%;
  }
}
</style>
